const cards = [
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20style%20image%20with%20dramatic%20lighting%2C%20a%20lonely%20figure%20standing%20in%20front%20of%20a%20glowing%20cinema%20screen%20in%20an%20empty%20theater%2C%20warm%20golden%20light%20casting%20long%20shadows%2C%20noir%20atmosphere%2C%20rich%20deep%20blacks%20and%20amber%20highlights%2C%20cinematic%20photography%2C%20moody%20and%20contemplative%20mood&width=640&height=900&seq=card-movie-01&orientation=portrait',
    title: '本周必看：五部不容错过的悬疑佳作',
    tag: '编辑精选',
    date: '2026-07-28',
    desc: '从烧脑反转的国产新片到经典重映的希区柯克，这个周末锁定夜猫影院悬疑专题。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20casting%20warm%20golden%20light%20beam%20across%20a%20dark%20room%20filled%20with%20floating%20dust%20particles%2C%20old%20film%20reels%20stacked%20nearby%2C%20nostalgic%20cinema%20atmosphere%2C%20rich%20contrast%20photography%2C%20warm%20amber%20tones%20against%20deep%20shadows%2C%20elegant%20and%20timeless%20composition&width=640&height=900&seq=card-movie-02&orientation=portrait',
    title: '国产科幻电影崛起之路：从追赶到引领',
    tag: '深度影评',
    date: '2026-07-25',
    desc: '盘点近五年国产科幻电影大全精选，从流浪地球到明日战记的进化之路。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20showing%20multiple%20overlapping%20film%20strips%20floating%20in%20darkness%20illuminated%20by%20soft%20golden%20rim%20light%2C%20each%20frame%20showing%20different%20miniature%20scenes%2C%20artistic%20double%20exposure%20style%2C%20elegant%20and%20sophisticated%2C%20warm%20and%20mysterious%20mood&width=640&height=900&seq=card-movie-03&orientation=portrait',
    title: '深夜观影指南：恐怖片爱好者的终极片单',
    tag: '专题合集',
    date: '2026-07-22',
    desc: '为勇敢的夜猫子准备的深夜惊悚电影大全免费在线看，胆小的别点。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Elegant%20red%20cinema%20curtains%20partially%20opened%20revealing%20a%20glowing%20screen%20with%20abstract%20colorful%20light%20patterns%2C%20velvet%20texture%20visible%2C%20theater%20atmosphere%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20luxurious%20and%20inviting%2C%20rich%20deep%20reds%20and%20warm%20golds&width=640&height=900&seq=card-movie-04&orientation=portrait',
    title: '动画电影大赏：全家一起看的十部暖心之作',
    tag: '合家欢推荐',
    date: '2026-07-20',
    desc: '精选适合全家观看的动画乐园，从皮克斯到吉卜力，每一部都是治愈良药。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Classic%20movie%20clapperboard%20resting%20on%20a%20dark%20wooden%20table%20surrounded%20by%20scattered%20vintage%20film%20photographs%2C%20soft%20warm%20side%20lighting%20creating%20gentle%20shadows%2C%20nostalgic%20and%20romantic%20cinema%20mood%2C%20rich%20textures%2C%20timeless%20elegance&width=640&height=900&seq=card-movie-05&orientation=portrait',
    title: '爱情电影推荐：那些让人心动的经典瞬间',
    tag: '浪漫精选',
    date: '2026-07-18',
    desc: '从怦然心动到爱在黎明破晓前，深夜重温那些最美好的爱情文艺电影。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Dark%20theater%20aisle%20viewed%20from%20behind%20with%20empty%20red%20seats%20and%20a%20distant%20glowing%20cinema%20screen%20showing%20abstract%20golden%20light%2C%20deep%20perspective%20composition%2C%20atmospheric%20and%20mysterious%2C%20rich%20contrast%20between%20darkness%20and%20warm%20projected%20light&width=640&height=900&seq=card-movie-06&orientation=portrait',
    title: '动作片迷必看：肾上腺素飙升的硬核推荐',
    tag: '硬核推荐',
    date: '2026-07-15',
    desc: '从疾速追杀到碟中谍，精选高清动作大片让你一次看过瘾，深夜不困系列。',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-article-fill text-primary-400 text-xs"></i></span>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">编辑推荐</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">精选推荐</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">夜猫编辑团队用心精选的深度影评与独家片单，每周更新</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card) => (
            <a
              key={card.title}
              href="#cards"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/50 hover:border-primary-500/20 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] bg-primary-500/80 text-background-950 font-medium whitespace-nowrap">{card.tag}</span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm md:text-base font-medium text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-400 leading-relaxed mb-3 flex-1 line-clamp-2">{card.desc}</p>
                <span className="text-[11px] text-foreground-500">{card.date}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}